<template>
  <div>
    <el-dropdown 
      ref="dropdownRef"
      trigger="click" 
      :hide-on-click="false" 
      placement="right" 
      @command="handleCommand"
      @visible-change="handleChange"
    >
    
      <el-input
        v-if="visible"
        v-model="quantity"
        readonly
      />
      <el-button v-else plain class="btn-block">
        {{ quantity }}
        <i class="fa fa-chevron-down el-icon--right text-primary" aria-hidden="true"></i>
      </el-button>
      <template #dropdown>
        <el-dropdown-menu class="d-flex px-1">
          <el-dropdown-item command="minus">
            <i class="fa fa-minus m-1" aria-hidden="true"></i>
          </el-dropdown-item>

          <el-dropdown-item command="plus" :disabled="quantity >= max">
            <i class="fa fa-plus m-1" aria-hidden="true"></i>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: { type: Number, required: true },
  min: { type: Number, default: 1 },
  max: { type: Number, default: 20 },
  // 數量選擇器在出現幾秒後自動關閉，0=不會關閉，要手動點Mask遮罩才會關閉
  autoClose: { type: Number, default: 5 },
})
const emit = defineEmits(['update:modelValue', 'change'])

const quantity = useVModel(props, 'modelValue', emit)

const { t, n } = useI18n()
const dropdownRef = ref()
const timeoutID = ref()
const qty = ref(0)
const visible = ref(false)

const handleCountDown = () => {
  if (!props.autoClose || !dropdownRef.value) {
    return
  }
  // console.debug(`handleCountDown:`,qty.value)
  
  timeoutID.value = setTimeout(() => {
    dropdownRef.value.handleClose()
    visible.value = false
  }, props.autoClose * 1000)
}

const handleChange = (val) => {
  // console.debug(`timeoutID:`, timeoutID.value, val)
  // console.debug(`handleChange:`,val)
  visible.value = val
  if (timeoutID.value) {
    clearTimeout(timeoutID.value)
  }
  
  if (val) {
    handleCountDown()
  }
}

const handleCommand = (command) => {
  // console.debug(`handleCommand: ${command}`)
  qty.value = props.modelValue + 0

  if (command == "plus") {
    qty.value += 1
  } else if (command == "minus") {
    qty.value -= 1
    if (qty.value < props.min) {
      qty.value = 0
    }
  }
  // console.debug(`handleCommand qty:`,qty.value)
  emit("change", qty.value)

  if (qty.value < 1) {
    // 刪除購物車
    dropdownRef.value.handleClose()
    visible.value = false
    return
  }
  // console.debug(`handleCommand timeoutID:`, timeoutID.value)

  if (timeoutID.value) {
    clearTimeout(timeoutID.value)
    handleCountDown()
  }
}

</script>